import React from 'react';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { findManualFinding } from '../observationUtils';

export interface ManualFindingDetailProps {
  observation: fhir.Observation;
}

export const ManualFindingDetail = (props: ManualFindingDetailProps) => {
  const { observation } = props;

  return <Text>{findManualFinding(observation)}</Text>;
};
